import { render, staticRenderFns } from "./WizardStep5.vue?vue&type=template&id=4be59a94"
import script from "./WizardStep5.vue?vue&type=script&lang=js"
export * from "./WizardStep5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports